import _ from '../../baseApp/shared/utils/ObjectUtils';

export const getInitialStateForEntityType = (entityType, initialValues = {}) => {
    switch (entityType) {
        case availableEntityTypes.openSpace:
            const { capacity } = initialValues;
            return {
                capacity: {
                    value: capacity,
                    error: undefined,
                    required: true
                }
            };
        case availableEntityTypes.company:
            const { websiteLink } = initialValues;
            return {
                websiteLink: {
                    value: websiteLink,
                    error: undefined,
                    required: true
                }
            };
        case availableEntityTypes.floor:
            const { imageLink } = initialValues;
            return {
                image: {
                    value: imageLink,
                    error: undefined,
                    required: false
                }
            };
        case availableEntityTypes.meetingRoom:
            const {
                provider,
                status,
                email,
                minimumSchedulingPeriod,
                operationTimeStart,
                operationTimeEnd,
                area,
                hasQuickBook,
                allowCancelQuickBook,
                checkInOpen,
                calendarDepth,
                maxMeetingTime,
                minMeetingTime,
                quickBookPeriod,
                tolerancePeriod,
                logoUrl
            } = initialValues;
            const meetingRoomCapacity = initialValues.capacity;

            return {
                status: {
                  value: status,
                  error: undefined,
                  required: true
                },
                email: {
                  value: email,
                  error: undefined,
                  required: true
                },
                provider: {
                    value: provider,
                    error: undefined,
                    required: true
                },
                minimumSchedulingPeriod: {
                    value: minimumSchedulingPeriod,
                    error: undefined,
                    required: true
                },
                operationTimeStart: {
                    value: operationTimeStart,
                    error: undefined,
                    required: true
                },
                operationTimeEnd: {
                    value: operationTimeEnd,
                    error: undefined,
                    required: true
                },
                capacity: {
                    value: meetingRoomCapacity,
                    error: undefined,
                    required: true
                },
                area: {
                    value: area,
                    error: undefined,
                    required: true
                },
                hasQuickBook: {
                    value: _.coalesce(hasQuickBook, false),
                    error: undefined,
                    required: true
                },
                allowCancelQuickBook: {
                    value: _.coalesce(allowCancelQuickBook, false),
                    error: undefined,
                    required: true
                },
                checkInOpen: {
                    value: checkInOpen,
                    error: undefined,
                    required: true
                },
                calendarDepth: {
                    value: calendarDepth,
                    error: undefined,
                    required: true
                },
                maxMeetingTime: {
                    value: maxMeetingTime,
                    error: undefined,
                    required: false
                },
                minMeetingTime: {
                    value: minMeetingTime,
                    error: undefined,
                    required: false
                },
                quickBookPeriod: {
                    value: quickBookPeriod,
                    error: undefined,
                    required: false
                },
                tolerancePeriod: {
                    value: tolerancePeriod,
                    error: undefined,
                    required: true
                },
                logoUrl: {
                    value: logoUrl,
                    error: undefined
                }
            };
        case availableEntityTypes.building:
            const {
                latitude,
                longitude,
                address,
                zipCode,
                parish,
                city,
                country,
                accessInformation,
                timezone,
                hasCheckInConfiguration,
                domain,
                enableNotification,
                autoCheckOutDelay,
                operationTimeStart : buildingOperationTimeStart,
                operationTimeEnd : buildingOperationTimeEnd
            } = initialValues;

            return {
                latitude: {
                    value: latitude,
                    error: undefined,
                    required: true
                },
                longitude: {
                    value: longitude,
                    error: undefined,
                    required: true
                },
                address: {
                    value: address,
                    error: undefined,
                    required: true
                },
                zipCode: {
                    value: zipCode,
                    error: undefined,
                    required: true
                },
                parish: {
                    value: parish,
                    error: undefined
                },
                city: {
                    value: city,
                    error: undefined,
                    required: true
                },
                country: {
                    value: country,
                    error: undefined,
                    required: true
                },
                accessInformation: {
                    value: accessInformation,
                    error: undefined
                },
                timezone: {
                    value: timezone,
                    error: undefined,
                    required: true
                },
                hasCheckInConfiguration: {
                    value: _.coalesce(hasCheckInConfiguration, false),
                    error: undefined,
                    required: true
                },
                domain: {
                    value: domain,
                    required: true,
                    error: undefined
                },
                enableNotification: {
                    value: _.coalesce(enableNotification, false),
                    error: undefined,
                    required: true
                },
                autoCheckOutDelay: {
                    value: autoCheckOutDelay,
                    error: undefined,
                    required: true
                },
                operationTimeStart: {
                    value: buildingOperationTimeStart,
                    error: undefined,
                    required: true
                },
                operationTimeEnd: {
                    value: buildingOperationTimeEnd,
                    error: undefined,
                    required: true
                }
            };
        default:
            return {};
    }
};

export const availableEntityTypes = ({
    openSpace: "openSpace",
    company: "company",
    meetingRoom: "meetingRoom",
    floor: "floor",
    building: "building",
    region: "region",
    basic: "basic"
});


export const entitiesAllowedParents = entityType => {
    return availableParentsOfEntityType[entityType];
}

const availableParentsOfEntityType = {
    [availableEntityTypes.company]: [
        [availableEntityTypes.basic]
    ],
    [availableEntityTypes.region]: [
        [
            availableEntityTypes.region,
            availableEntityTypes.company
        ]
    ],
    [availableEntityTypes.building]: [
        [
            availableEntityTypes.region,
            availableEntityTypes.company
        ]
    ],
    [availableEntityTypes.floor]: [
        [availableEntityTypes.building]
    ],
    [availableEntityTypes.meetingRoom]: [
        [availableEntityTypes.floor]
    ],
    [availableEntityTypes.openSpace]: [
        [availableEntityTypes.floor]
    ]
}
